import BaseService from "./base.service";

class coefficientMultiplier extends BaseService {
  constructor() {
    super("coefficient-multiplier");
  }
}

export default new coefficientMultiplier();
